// import { CardFamily } from "./loyality.model";
import { CardFamily } from "./loyality.model";
import { MenuItemModel } from "./menu-item.model";

export class ProfileModel {
  id: number;
  hotel_id: number;
  created_at: Date;
  updated_at: Date;
  first_name: string;
  middle_name: string;
  last_name: string;
  room_no: string;
  profile_pic_url: string;
  locale: string;
  timezone: number;
  gender: string;
  entry_date: Date;
  release_date: Date;
  address: string;
  city: string;
  password: string;
  country: string;
  phone_country_id: string;
  phone_prefix_id: string;
  phone_no: string;
  mobile_country_id: string;
  mobile_prefix_id: string;
  mobile_no: string;
  voucher_or_booking_no: string;
  booking_date: Date;
  date_of_birth: Date;
  birth_place: string;
  nationality: string;
  travel_doc_type: string;
  travel_doc_id: string;
  document_issued_on: Date;
  document_issued_in: string;
  e_mail: string;
  personal_data: boolean;
  privacy_policy: boolean;
  agent_name: string;
  id_no: string;
  wedding_anniversary: Date;
  allergy: boolean;
  allergy_description: string;
  vehicle_no: string;
  passport_front_image_url: string;
  passport_back_image_url: string;
  email_permission: boolean;
  invoice_info: boolean;
  company_name: string;
  invoice_id_no: string;
  tax_area: string;
  tax_no: string;
  company_address: string;
  invoice_mail: string;
  staff_name: string;
  arrival_hour: Date;
  guest_status: string;
  child_person: boolean;

  signature: string;
  loyalty_card_no: string;
  loyalty_card_family_id: number;
  loyalty_card_family_content_id: number;
  loyalty_card_family_name: string;
  special_loyalty_member: boolean;
  loyalty_info: Loyaltyinfo;
  loyaltyMenuItem: MenuItemModel;
  cardFamily: CardFamily;
  badge_a: any;

  constructor(id: 0,
    hotel_id = 0,
    created_at = new Date(),
    updated_at = new Date(),
    first_name = '',
    middle_name = '',
    last_name = '',
    room_no = '',
    profile_pic_url = '',
    locale = '',
    timezone: number,
    gender = '',
    entry_date = new Date(),
    release_date = new Date(),
    address = '',
    city = '',
    country = '',
    phone_country_id = '',
    phone_prefix_id = '',
    phone_no = '',
    mobile_country_id = '',
    mobile_prefix_id = '',
    mobile_no = '',
    voucher_or_booking_no = '',
    booking_date = new Date(),
    date_of_birth = new Date(),
    birth_place = '',
    nationality = '',
    travel_doc_type = '',
    travel_doc_id = '',
    document_issued_on = new Date(),
    document_issued_in = '',
    e_mail = '',
    personal_data = true,
    privacy_policy = true,
    agent_name = '',
    id_no = '',
    wedding_anniversary = new Date(),
    allergy = false,
    allergy_description = '',
    vehicle_no = '',
    passport_front_image_url = '',
    passport_back_image_url = '',
    email_permission = true,
    invoice_info = false,
    company_name = '',
    invoice_id_no = '',
    tax_area = '',
    tax_no = '',
    company_address = '',
    invoice_mail = '',
    staff_name = '',
    arrival_hour = new Date(),
    guest_status = '') {
    this.id = id;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.first_name = first_name;
    this.middle_name = middle_name;
    this.last_name = last_name;
    this.room_no = room_no;
    this.profile_pic_url = profile_pic_url;
    this.locale = locale;
    this.timezone = timezone;
    this.gender = gender;
    this.entry_date = entry_date;
    this.release_date = release_date;
    this.address = address;
    this.city = city;
    this.country = country;
    this.phone_country_id = phone_country_id;
    this.phone_prefix_id = phone_prefix_id;
    this.phone_no = phone_no;
    this.mobile_country_id = mobile_country_id;
    this.mobile_prefix_id = mobile_prefix_id;
    this.mobile_no = mobile_no;
    this.voucher_or_booking_no = voucher_or_booking_no;
    this.booking_date = booking_date;
    this.date_of_birth = date_of_birth;
    this.birth_place = birth_place;
    this.nationality = nationality;
    this.travel_doc_type = travel_doc_type;
    this.travel_doc_id = travel_doc_id;
    this.document_issued_on = document_issued_on;
    this.document_issued_in = document_issued_in;
    this.e_mail = e_mail;
    this.personal_data = personal_data;
    this.privacy_policy = privacy_policy;
    this.hotel_id = hotel_id;
    this.agent_name = agent_name;
    this.id_no = id_no;
    this.wedding_anniversary = wedding_anniversary;
    this.allergy = allergy;
    this.allergy_description = allergy_description;
    this.vehicle_no = vehicle_no;
    this.passport_front_image_url = passport_front_image_url;
    this.passport_back_image_url = passport_back_image_url;
    this.email_permission = email_permission;
    this.invoice_info = invoice_info;
    this.company_name = company_name;
    this.invoice_id_no = invoice_id_no;
    this.tax_area = tax_area;
    this.tax_no = tax_no;
    this.company_address = company_address;
    this.invoice_mail = invoice_mail;
    this.staff_name = staff_name;
    this.arrival_hour = arrival_hour;
    this.guest_status = guest_status;
  }
}

export interface Loyaltyinfo {
  points_earned: number;
  points_spend: number;
  remaining_point: number;
  overnight_stay: number;
  target_night_stay: number;
  earned_night_stay: number;
  room_type: string;
  menu_item_id: number;
}

export class NewProfile {
  id: number;
  hotel_id: number;
  created_at: Date;
  updated_at: Date;
  first_name: string;
  middle_name: string;
  last_name: string;
  room_no: string;
  profile_pic_url: string;
  locale: string;
  timezone: number;
  gender: string;
  entry_date: Date;
  release_date: Date;
  address: string;
  city: string;
  country: string;
  phone_country_id: string;
  phone_prefix_id: string;
  phone_no: string;
  mobile_country_id: string;
  mobile_prefix_id: string;
  mobile_no: string;
  voucher_or_booking_no: string;
  booking_date: Date;
  date_of_birth: Date;
  birth_place: string;
  nationality: string;
  travel_doc_type: string;
  travel_doc_id: string;
  document_issued_on: Date;
  document_issued_in: string;
  e_mail: string;
  personal_data: boolean;
  privacy_policy: boolean;
  agent_name: string;
  id_no: string;
  wedding_anniversary: Date;
  allergy: boolean;
  allergy_description: string;
  vehicle_no: string;
  passport_front_image_url: string;
  passport_back_image_url: string;
  email_permission: boolean;
  invoice_info: boolean;
  company_name: string;
  invoice_id_no: string;
  tax_area: string;
  tax_no: string;
  company_address: string;
  invoice_mail: string;
  staff_name: string;
  arrival_hour: Date;
  guest_status: string;
  child_person: boolean;
  signature: string;
  loyalty_card_no: string;
  loyalty_card_family_id: number;
  loyalty_card_family_name: string;
  special_loyalty_member: boolean;

  constructor() {
    this.id = 0;
    this.hotel_id = 0;
    this.created_at = new Date();
    this.updated_at = new Date();
    this.first_name = '';
    this.middle_name = '';
    this.last_name = '';
    this.room_no = '';
    this.profile_pic_url = '';
    this.locale = '';
    this.timezone = 0;
    this.gender = '';
    this.entry_date = new Date();
    this.release_date = new Date();
    this.address = '';
    this.city = '';
    this.country = '';
    this.phone_country_id = '';
    this.phone_prefix_id = '';
    this.phone_no = '';
    this.mobile_country_id = '';
    this.mobile_prefix_id = '';
    this.mobile_no = '';
    this.voucher_or_booking_no = '';
    this.booking_date = new Date();
    this.date_of_birth = new Date();
    this.birth_place = '';
    this.nationality = '';
    this.travel_doc_type = '';
    this.travel_doc_id = '';
    this.document_issued_on = new Date();
    this.document_issued_in = '';
    this.e_mail = '';
    this.personal_data = true;
    this.privacy_policy = true;
    this.agent_name = '';
    this.id_no = '';
    this.wedding_anniversary = new Date();
    this.allergy = false;
    this.allergy_description = '';
    this.vehicle_no = '';
    this.passport_front_image_url = '';
    this.passport_back_image_url = '';
    this.email_permission = true;
    this.invoice_info = false;
    this.company_name = '';
    this.invoice_id_no = '';
    this.tax_area = '';
    this.tax_no = '';
    this.company_address = '';
    this.invoice_mail = '';
    this.staff_name = '';
    this.arrival_hour = new Date();
    this.guest_status = '';
    this.loyalty_card_no = '';
    this.loyalty_card_family_id = 0;
    this.loyalty_card_family_name = '';
    this.special_loyalty_member = false;
  }
}
